export default "__VITE_ASSET__2cbcde4e__"